'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { ButtonIcon } from '../ui/button-icon';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

const profileButtonClassName = 'min-h-6 min-w-[6.5rem] whitespace-nowrap disabled:opacity-100';

export const HeaderProfileButton = () => {
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    if (!isInitialized || me) return;
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!isInitialized || !me) {
    return (
      <Button
        variant={'none'}
        size={'none'}
        className={profileButtonClassName}
        disabled={!isInitialized}
        aria-busy={!isInitialized}
        onClick={handleSignInClick}
      >
        Prihlásenie
      </Button>
    );
  }

  if (me && isInitialized) {
    return (
      <Button asChild variant={'none'} size={'none'} className={profileButtonClassName}>
        <Link prefetch={false} href={ROUTES.PROFILE()} aria-label="Profil">
          <ButtonIcon
            alt="Profil"
            url="/images/icons/user-black.svg"
            className="max-h-6 min-h-6 min-w-6 max-w-6"
          />
        </Link>
      </Button>
    );
  }
};
